import React from "react";
import LogoCircular from "../assets/LogoCircular.png"; // Import your logo
import ItalianFlagVideo from "../assets/italianFlagVideo.mp4"; // Import the Italian flag video

export const LoadingScreen = () => {
  return (
    <div className="fixed top-0 left-0 h-screen w-full flex items-center justify-center z-50">
      {/* Video Background */}
      <video
        className="absolute top-0 left-0 h-full w-full sm:object-cover object-fill "
        autoPlay
        loop
        muted
        playsInline
      >
        <source src={ItalianFlagVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Logo */}
      <img
        src={LogoCircular}
        alt="Circular Logo"
        className="h-[300px] w-auto  sm:h-[500px] z-10"
      />
    </div>
  );
};
